exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-metadata{margin-top:15px;margin-bottom:10px;display:flex;justify-content:center}.input{width:30%;height:20px}.add-metadata{margin-bottom:15px;display:flex;justify-content:center;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11e23ae4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserDefinedField.vue
// module id = 48
// module chunks = 0